import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { reportingService } from '../../services/reportingService';

export const useGetSubmittedReports = params => {
  return useQuery({
    queryKey: [QUERY_KEYS.reporting.submitted_reports, params],
    refetchOnWindowFocus: false,
    queryFn: () =>
      reportingService.submittedReports({ ...params, limit: 20 }).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
      }),
  });
};
